module.exports = __webpack_public_path__ + "static/mreavesxlsannaru-020415006EmigreWebOnly-52c5caaf47b2ebca9e6c1724aacf2c11.woff2";